import { initializeApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyDmrd7ruQt9UhUguA2QHCfkeEHoz2MifdA",
    authDomain: "espaciocompato.firebaseapp.com",
    projectId: "espaciocompato",
    storageBucket: "espaciocompato.firebasestorage.app",
    messagingSenderId: "296850104361",
    appId: "1:296850104361:web:4edf04f601a24214447c38",
    measurementId: "G-0QQJB5XXNG"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence);
const analytics = getAnalytics(app);

export { db, storage, auth, analytics };
